export function Header() {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/quickdraw.png" alt="Quick Draw Funding" className="h-12" />
        </div>
        <div className="text-right">
          <p className="text-sm font-semibold text-brand-700 tracking-wide uppercase">Left Main REI</p>
          <p className="text-xs text-gray-400">Transaction Intake Portal</p>
        </div>
      </div>
    </header>
  );
}
